import { createContext } from 'react';

import { DesignVersioningContextType } from './types';

export const DesignVersioningContext = createContext<
  DesignVersioningContextType | undefined
>(undefined);
